import { InternalLocale, RFC4646Locale, StripeLocale, LocaleLabel, } from './types';
export const INTERNAL_TO_RFC4646_LOCALES = {
    [InternalLocale.DANISH]: RFC4646Locale.DANISH,
    [InternalLocale.GERMAN]: RFC4646Locale.GERMAN,
    [InternalLocale.GREEK]: RFC4646Locale.GREEK,
    [InternalLocale.ENGLISH]: RFC4646Locale.ENGLISH,
    [InternalLocale.SPANISH]: RFC4646Locale.SPANISH,
    [InternalLocale.FINNISH]: RFC4646Locale.FINNISH,
    [InternalLocale.FRENCH]: RFC4646Locale.FRENCH,
    [InternalLocale.HUNGARIAN]: RFC4646Locale.HUNGARIAN,
    [InternalLocale.ITALIAN]: RFC4646Locale.ITALIAN,
    [InternalLocale.DUTCH]: RFC4646Locale.DUTCH,
    [InternalLocale.NORWEGIAN]: RFC4646Locale.NORWEGIAN,
    [InternalLocale.POLISH]: RFC4646Locale.POLISH,
    [InternalLocale.PORTUGUESE]: RFC4646Locale.PORTUGUESE,
    [InternalLocale.ROMANIAN]: RFC4646Locale.ROMANIAN,
    [InternalLocale.SWEDISH]: RFC4646Locale.SWEDISH,
    [InternalLocale.CHINESE_SIMPLIFIED]: RFC4646Locale.CHINESE_SIMPLIFIED,
    [InternalLocale.CHINESE_TRADITIONAL]: RFC4646Locale.CHINESE_TRADITIONAL,
};
export const RFC4646_TO_INTERNAL_LOCALES = {
    [RFC4646Locale.DANISH]: InternalLocale.DANISH,
    [RFC4646Locale.GERMAN]: InternalLocale.GERMAN,
    [RFC4646Locale.GREEK]: InternalLocale.GREEK,
    [RFC4646Locale.ENGLISH]: InternalLocale.ENGLISH,
    [RFC4646Locale.SPANISH]: InternalLocale.SPANISH,
    [RFC4646Locale.FINNISH]: InternalLocale.FINNISH,
    [RFC4646Locale.FRENCH]: InternalLocale.FRENCH,
    [RFC4646Locale.HUNGARIAN]: InternalLocale.HUNGARIAN,
    [RFC4646Locale.ITALIAN]: InternalLocale.ITALIAN,
    [RFC4646Locale.DUTCH]: InternalLocale.DUTCH,
    [RFC4646Locale.NORWEGIAN]: InternalLocale.NORWEGIAN,
    [RFC4646Locale.POLISH]: InternalLocale.POLISH,
    [RFC4646Locale.PORTUGUESE]: InternalLocale.PORTUGUESE,
    [RFC4646Locale.ROMANIAN]: InternalLocale.ROMANIAN,
    [RFC4646Locale.SWEDISH]: InternalLocale.SWEDISH,
    [RFC4646Locale.CHINESE_SIMPLIFIED]: InternalLocale.CHINESE_SIMPLIFIED,
    [RFC4646Locale.CHINESE_TRADITIONAL]: InternalLocale.CHINESE_TRADITIONAL,
};
export const INTERNAL_TO_STRIPE_LOCALES = {
    [InternalLocale.DANISH]: StripeLocale.DANISH,
    [InternalLocale.GERMAN]: StripeLocale.GERMAN,
    [InternalLocale.GREEK]: StripeLocale.GREEK,
    [InternalLocale.ENGLISH]: StripeLocale.ENGLISH,
    [InternalLocale.SPANISH]: StripeLocale.SPANISH,
    [InternalLocale.FINNISH]: StripeLocale.FINNISH,
    [InternalLocale.FRENCH]: StripeLocale.FRENCH,
    [InternalLocale.HUNGARIAN]: StripeLocale.HUNGARIAN,
    [InternalLocale.ITALIAN]: StripeLocale.ITALIAN,
    [InternalLocale.DUTCH]: StripeLocale.DUTCH,
    [InternalLocale.NORWEGIAN]: StripeLocale.NORWEGIAN,
    [InternalLocale.POLISH]: StripeLocale.POLISH,
    [InternalLocale.PORTUGUESE]: StripeLocale.PORTUGUESE,
    [InternalLocale.ROMANIAN]: StripeLocale.ROMANIAN,
    [InternalLocale.SWEDISH]: StripeLocale.SWEDISH,
    [InternalLocale.CHINESE_SIMPLIFIED]: StripeLocale.CHINESE_SIMPLIFIED,
    [InternalLocale.CHINESE_TRADITIONAL]: StripeLocale.CHINESE_TRADITIONAL,
};
export const RFC4646_LOCALES_TO_LABELS = {
    [RFC4646Locale.DANISH]: LocaleLabel.DANISH,
    [RFC4646Locale.GERMAN]: LocaleLabel.GERMAN,
    [RFC4646Locale.GREEK]: LocaleLabel.GREEK,
    [RFC4646Locale.ENGLISH]: LocaleLabel.ENGLISH,
    [RFC4646Locale.SPANISH]: LocaleLabel.SPANISH,
    [RFC4646Locale.FINNISH]: LocaleLabel.FINNISH,
    [RFC4646Locale.FRENCH]: LocaleLabel.FRENCH,
    [RFC4646Locale.HUNGARIAN]: LocaleLabel.HUNGARIAN,
    [RFC4646Locale.ITALIAN]: LocaleLabel.ITALIAN,
    [RFC4646Locale.DUTCH]: LocaleLabel.DUTCH,
    [RFC4646Locale.NORWEGIAN]: LocaleLabel.NORWEGIAN,
    [RFC4646Locale.POLISH]: LocaleLabel.POLISH,
    [RFC4646Locale.PORTUGUESE]: LocaleLabel.PORTUGUESE,
    [RFC4646Locale.ROMANIAN]: LocaleLabel.ROMANIAN,
    [RFC4646Locale.SWEDISH]: LocaleLabel.SWEDISH,
    [RFC4646Locale.CHINESE_SIMPLIFIED]: LocaleLabel.CHINESE_SIMPLIFIED,
    [RFC4646Locale.CHINESE_TRADITIONAL]: LocaleLabel.CHINESE_TRADITIONAL,
};
